var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import momentTZ from "moment-timezone";
export const findAsync = (arr, callback) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < arr.length; i++) {
        const result = yield callback(arr[i], i, arr);
        if (result) {
            return arr[i];
        }
    }
    return undefined;
});
export const mapAsync = (arr, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const result = [];
    for (let i = 0; i < arr.length; i++) {
        const mappedValue = yield callback(arr[i], i, arr);
        result.push(mappedValue);
    }
    return result;
});
export const filterAsync = (arr, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const result = [];
    for (let i = 0; i < arr.length; i++) {
        const filteredValue = yield callback(arr[i], i, arr);
        if (filteredValue) {
            result.push(arr[i]);
        }
    }
    return result;
});
export const findIndexAsync = (arr, callback) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < arr.length; i++) {
        const result = yield callback(arr[i], i, arr);
        if (result) {
            return i;
        }
    }
    return -1;
});
export const sortRule = (valueA, valueB, sort) => {
    if (Number.isNaN(valueA) ||
        Number.isNaN(valueB) ||
        typeof valueA === "undefined" ||
        typeof valueB === "undefined" ||
        valueA === null ||
        valueB === null) {
        return 1;
    }
    else {
        if (valueA >= valueB) {
            if (sort) {
                return 1;
            }
            return -1;
        }
        else {
            if (sort) {
                return -1;
            }
            return 1;
        }
    }
};
export const getAppTimezone = (inputTz) => {
    var _a;
    const _appTimeZone = (_a = window === null || window === void 0 ? void 0 : window.appInfo) === null || _a === void 0 ? void 0 : _a.appTimeZone;
    const tz = inputTz === "global" ? _appTimeZone : inputTz;
    if (tz && tz !== "user") {
        // 指定的固定的时区
        return tz;
    }
    else {
        // 用户本地时区，包括 tz 是 null 的场景
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
};
const validIANATimezoneCache = {};
// 判断是否是有效的时区字符
export function isValidTimezoneIANAString(timezoneString) {
    if (validIANATimezoneCache[timezoneString])
        return true;
    try {
        new Intl.DateTimeFormat(undefined, { timeZone: timezoneString });
        validIANATimezoneCache[timezoneString] = true;
        return true;
    }
    catch (error) {
        return false;
    }
}
export function naslDateToLocalDate(date) {
    const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDate = momentTZ.tz(date, "YYYY-MM-DD", localTZ);
    return safeNewDate(localDate.format("YYYY-MM-DD HH:mm:ss"));
}
export function convertJSDateInTargetTimeZone(date, tz) {
    return safeNewDate(momentTZ.tz(safeNewDate(date), getAppTimezone(tz)).format("YYYY-MM-DD HH:mm:ss"));
}
export const safeNewDate = (dateStr) => {
    // 如果输入是字符串形式的时间戳，则先转换为时间戳
    if (typeof dateStr === "string" && /^\d+$/.test(dateStr)) {
        const date = new Date(parseInt(dateStr, 10));
        if (!isNaN(date.getTime())) {
            return date;
        }
    }
    try {
        const res = new Date(dateStr.replaceAll("-", "/"));
        if (["Invalid Date", "Invalid time value", "invalid date"].includes(res.toString())) {
            return new Date(dateStr);
        }
        else {
            return res;
        }
    }
    catch (err) {
        return new Date(dateStr);
    }
};
